import React from 'react';

const MeetUs = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Meet Us</h1>
        <p>Our leadership and team</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>Board of Patrons</h2>
              <button className="btn-gold" onClick={() => window.location.href='/board-patrons'}>View Patrons</button>
            </div>
            <div className="content-card">
              <h2>Board of Directors</h2>
              <button className="btn-gold" onClick={() => window.location.href='/board-directors'}>View Directors</button>
            </div>
            <div className="content-card">
              <h2>Management Staff</h2>
              <button className="btn-gold" onClick={() => window.location.href='/management-staff'}>View Staff</button>
            </div>
            <div className="content-card">
              <h2>Interns & Volunteers</h2>
              <button className="btn-gold" onClick={() => window.location.href='/interns-volunteers'}>View Team</button>
            </div>
            <div className="content-card">
              <h2>Contact Us</h2>
              <button className="btn-gold" onClick={() => window.location.href='/contact-us'}>Get in Touch</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MeetUs;